import * as dateUtils from '../../../util/date_utils'
import * as timeUtils from '../../../util/time_utils'
import moment from "moment-timezone"
const timezone = moment.tz.guess()

function createQuery(range, id, tags, ownerId) {
    const { start: startAt, end: endAt } = range
    return { id, startAt: startAt / 1000, endAt: endAt / 1000, tags, ownerId, timezone }
}

function generateQueries(today, span, tagIds, interval='Year', ownerId) {
    const week = dateUtils.getDefaultTimespan('Week', today)
    const month = dateUtils.getDefaultTimespan('Month', today)
    const year = dateUtils.getDefaultTimespan('Year', today)

    const summaryQueries = [
        createQuery(week, 'thisWeek', tagIds, ownerId),
        createQuery(month, 'thisMonth', tagIds, ownerId),
        createQuery(year, 'thisYear', tagIds, ownerId),
    ]

    const subdivisions = dateUtils.subdivide(span, interval)
    const detailQueries = subdivisions.map( span => createQuery(span, `detail-${span.start}`, tagIds, ownerId) )
    return [ ...summaryQueries, ...detailQueries ]
}

function toHours(tagReport) {
    return secondsToHours(tagReport ? tagReport.totalDuration : 0)
}

export const secondsToHours = (seconds) => {
    return timeUtils.make2Places(timeUtils.make2Places(seconds) / 60 / 60 )
}

function toBarChartData(tagReports, subInterval) {
    if (!tagReports) return []

    const toValue = id => parseFloat(toHours(tagReports.items['detail-' + id]))
    const toLabel = subInterval === 'Week' || subInterval === 'Month'
        ? id => dateUtils.dateRangeString(
            subInterval,
            dateUtils.getDefaultTimespan(subInterval, id),
            {short:true, hideYear:true}
        )
        : id => dateUtils.formatDateTs(id, {short: true, hideYear: true, hideDay: true})

    return tagReports.sort
        .filter( id => id.indexOf('detail') > -1 )
        .map( id => parseInt(id.replace('detail-', '')) )
        .sort( (a, b) => a - b )
        .map( id => ({label: toLabel(id), value: toValue(id)}))
}

function toUserData(tagReports, subInterval) {
    if (!tagReports) return []

    const toLabel = subInterval === 'Week' || subInterval === 'Month'
        ? id => dateUtils.dateRangeString(
            subInterval,
            dateUtils.getDefaultTimespan(subInterval, id),
            {short:true, hideYear:true}
        )
        : id => dateUtils.formatDateTs(id, {short: true, hideYear: true, hideDay: true})

    return tagReports.sort
        .filter( id => id.indexOf('detail') > -1 )
        .reduce( (acc, id) => {
            const details = (tagReports.items[id] || {}).detail || []

            const userData = details.map( d => ({
                userId: d.ownerId,
                label: toLabel(parseInt(id.replace('detail-', ''))),
                value: parseFloat(d.totalDuration),
            }))

            return [...acc, ...userData]
        }, [] )
        .reduce( (acc, data) => ({
            ...acc,
            [data.userId]: [...(acc[[data.userId]] || []), data],
        }), {})
}

export {
    createQuery,
    generateQueries,
    toBarChartData,
    toUserData,
    toHours,
}


// WEBPACK FOOTER //
// ./src/common/components/modals/tag_report_modal.js